import { ReactNode } from 'react'

import { TruncateLinesWrapper } from './index.styles'

export default ({ children, lines, lineHeight = 1.5 }: { children: ReactNode; lines: number; lineHeight?: number }) => {
  return (
    <TruncateLinesWrapper $lines={lines} $lineHeight={lineHeight}>
      {children}
    </TruncateLinesWrapper>
  )
}
